import { Utensils, Compass, ShoppingBag } from 'lucide-react';

const MARKETPLACE_ICONS = {
  Utensils: <Utensils className="w-5 h-5 text-primary" />,
  Compass: <Compass className="w-5 h-5 text-primary" />,
  ShoppingBag: <ShoppingBag className="w-5 h-5 text-primary" />
};

const MarketplaceCards = ({ marketplaces = [] }) => {
  return (
    <div
      data-tour="market"
      className="grid grid-cols-1 md:grid-cols-3 gap-3.5 sm:gap-4 lg:gap-5 mt-4 sm:mt-6"
    >
      {marketplaces.map((item) => {
        const icon = typeof item.icon === 'string' ? MARKETPLACE_ICONS[item.icon] : item.icon;

        return (
          <div
            key={item.id}
            className="bg-white rounded-2xl p-4 sm:p-5 border border-slate-200/80 hover:border-primary/40 hover:shadow-md transition-all duration-200 flex flex-col justify-between group"
          >
            <div>
              {/* Icon */}
              <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-[#eaf8f7] border border-[#c2ecea]/50 text-primary flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-primary/10 transition-colors">
                {icon}
              </div>

              {/* Title */}
              <h3 className="text-base sm:text-lg font-normal text-slate-800 tracking-tight">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-xs sm:text-sm text-slate-600 leading-relaxed mt-1.5 sm:mt-2">
                {item.description}
              </p>
            </div>

            {/* Earning Highlight Tag */}
            <div className="mt-3.5 sm:mt-5 pt-2.5 sm:pt-3 border-t border-slate-100">
              <span className="text-xs font-medium text-primary">
                {item.earningTag}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MarketplaceCards;
